import React, { useState } from "react";
import { TextArea, Button } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { ModalBuilder, Modal, Form, ErrorMessage } from "@redriver/cinnamon";
import { WriteTextToClipboardButton } from "features/../../../shared/components/buttons";
import {
  DealerOfficesTypeAheadLookup,
  UserTypeAhead,
} from "features/../../../shared/features/Settings";
import { getCustomerCrmUrl } from "features/Companies/Customers/actions";
import { getCrmClientDetails } from "pages/Companies/Customers/actions";

const CrmLinkModal = ({ clientId }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [output, setOutput] = useState(undefined);
  const [error, setError] = useState(undefined);

  return (
    <ModalBuilder
      withForm
      renderTrigger={(onShowModal) => (
        <Button primary icon="code" content="CRM Link" onClick={onShowModal} />
      )}
      loadAction={getCrmClientDetails}
      loadParams={clientId}
      renderModal={(modalProps, formProps) => (
        <Modal
          {...modalProps}
          header="Generate CRM URL"
          className="crm-url-modal"
          cancelLabel="Close"
          submitLabel="Generate"
          loading={loading}
          slowLoading={loading}
          onSubmit={() => {
            setLoading(true);
            (async () => {
              const { response, error } = await dispatch(
                getCustomerCrmUrl(formProps.value),
              );
              setError(error);
              setOutput(response?.urlEncoded);
              setLoading(false);
            })();
          }}
        >
          <Form {...formProps}>
            <div className="step details">
              <Form.Input
                field="name"
                label="Client Name"
                fluid
                inline
                required
              />
              <Form.Input field="code" label="Code" fluid inline disabled />
            </div>
            <div className="step details" style={{ marginBottom: "1em" }}>
              <Form.Input
                field="crmCompanyId"
                label="Company Id"
                fluid
                inline
                required
              />
              <Form.Input
                field="companyRegNo"
                label="Company Reg Number"
                fluid
                inline
              />
            </div>
            <div className="step details">
              <DealerOfficesTypeAheadLookup
                field="dealerOfficeId"
                textField="dealerOffice"
                fluid
                label="Supplier Office"
              />
              <UserTypeAhead
                fluid
                required
                placeholder="Search Users"
                field="userId"
                label="Member User"
                lookupParams={{
                  dealerOfficeId: formProps.value.dealerOfficeId,
                  includeInternalUsers: true,
                }}
              />
            </div>
            <div className="step details">
              <Form.Input
                field="businessType"
                label="Business Type"
                fluid
                inline
                disabled
              />
              <Form.Input
                field="ContactName"
                label="Contact Name"
                fluid
                inline
              />
            </div>
            <div className="step details">
              <Form.Input field="tradingAs" label="Trading As" fluid inline />
            </div>
            <div className="step details">
              <Form.Input field="phone" label="Phone" fluid inline />
              <Form.Input field="email" label="Email" fluid inline />
            </div>
            <div className="step details">
              <Form.Input
                field="addressLine1"
                label="Address Line 1"
                fluid
                inline
              />
              <Form.Input
                field="addressLine2"
                label="Address Line 2"
                fluid
                inline
              />
            </div>
            <div className="step details">
              <Form.Input field="town" label="Town" fluid inline />
              <Form.Input field="county" label="County" fluid inline />
            </div>
            <div className="step details">
              <Form.Input
                field="postcode"
                label="Postcode"
                fluid
                inline
                required
              />
              <Form.Input field="country" label="Country" fluid inline />
            </div>

            <ErrorMessage error={error} />
            {output && (
              <React.Fragment>
                <TextArea readOnly value={output} rows={5} />
                <div className="flex end">
                  <WriteTextToClipboardButton valueToWrite={output} />
                </div>
              </React.Fragment>
            )}
          </Form>
        </Modal>
      )}
    />
  );
};

export default CrmLinkModal;
